<mat-card id="page-content">
    <mat-card-content>
        <form [formGroup]="form" class="form-container">
            <!-- Group Name -->
            <div class="group-select-row">
                <mat-form-field appearance="outline">
                    <mat-label>{{ 'GROUP_NAME' | translate }}</mat-label>
                    <mat-select formControlName="groupId" size="small">
                        <input id="search-select" class="w-100 border-0 p-1"
                            (input)="filteredgroupsList=onFilteredListSearch($event, groupsList, 'name')"
                            placeholder="Search {{ 'GROUP_NAME' | translate }}" />
                        @for (ct of filteredgroupsList; track ct) {
                        <mat-option [value]="ct.groupId">{{ ct.name }}</mat-option>
                        }
                    </mat-select>
                    @if (f['groupId'].errors) {
                    <mat-error>
                        @if (f['groupId'].errors['required']) {
                        <span>{{ 'FIELD_REQUIRED' | translate }}</span>
                        }
                    </mat-error>
                    }
                </mat-form-field>
            </div>

            @if (f['groupId'].value) {
            <!-- Action Bar -->
            <div class="action-bar">
                @if (hasUnsavedChanges) {
                <span class="unsaved-indicator">Unsaved changes</span>
                <button class="btn-discard" (click)="discardChanges()">Discard</button>
                }
                <button class="btn-update" [disabled]="!hasUnsavedChanges" (click)="updateUsers()">Update Users</button>
            </div>

            <!-- Users Section -->
            <div class="rights-section">
                <div class="section-header">
                    <span class="section-title">Users</span>
                </div>
                <div class="section-body">
                    <div class="panel">
                        <div class="panel-header">
                            <span class="panel-label">Available</span>
                            <span class="panel-count">({{displayUsersList.length}})</span>
                        </div>
                        <input class="panel-search" placeholder="Search..."
                            [(ngModel)]="availableSearch" [ngModelOptions]="{standalone: true}" />
                        <div class="panel-list">
                            @for (user of filterBySearch(displayUsersList, availableSearch); track user) {
                            <div class="list-item" [class.checked]="isCheckedAvailable(user)" (click)="toggleAvailableCheck(user)">
                                <span class="item-check"></span>
                                <span>{{user.userName}}</span>
                            </div>
                            }
                        </div>
                        <div class="panel-footer">
                            <a class="action-link add-link" (click)="selectAll()">Add All &rarr;</a>
                        </div>
                    </div>
                    <div class="transfer-controls">
                        <button class="arrow-btn arrow-right" (click)="moveToAssigned()">&rsaquo;</button>
                        <button class="arrow-btn arrow-left" (click)="moveToAvailable()">&lsaquo;</button>
                    </div>
                    <div class="panel">
                        <div class="panel-header">
                            <span class="panel-label">Assigned</span>
                            <span class="panel-count-badge">{{selectedUsersList.length}}</span>
                        </div>
                        <input class="panel-search" placeholder="Search..."
                            [(ngModel)]="assignedSearch" [ngModelOptions]="{standalone: true}" />
                        <div class="panel-list">
                            @for (user of filterBySearch(selectedUsersList, assignedSearch); track user) {
                            <div class="list-item" [class.checked]="isCheckedAssigned(user)" (click)="toggleAssignedCheck(user)">
                                <span class="item-check"></span>
                                <span>{{user.userName}}</span>
                            </div>
                            }
                        </div>
                        <div class="panel-footer">
                            <a class="action-link remove-link" (click)="removeAll()">&larr; Remove All</a>
                        </div>
                    </div>
                </div>
            </div>
            }
        </form>
    </mat-card-content>
</mat-card>
